import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reset, destroy } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import isEmpty from 'lodash/isEmpty';
import {
  getOrgSitesAction,
  siteAddAction,
  areaAddAction,
  editAreaAction,
  areaExpandAction,
  getAreasAction,
  zoneAddAction,
  getZonesAction,
  locationAddAction,
  getLocationsAction,
  setCurrentLocationAction,
  locationEditAction,
  deleteLocationAction,
  deleteZoneAction,
  deleteAreaAction,
  deleteSiteAction,
  setCurrentSiteAction,
  editSiteAction,
  editZoneAction,
  editSiteLabelsAction
} from '../../reducers/actions';
import styles from './Admin.styles';
import { ICON_TYPE } from '../../constants/icons';

import Accordion from '../../components/data/accordion/Accordion';
import AddAreaForm from '../../components/forms/addareaform/AddAreaForm';
import AreaInfoForm from '../../components/forms/editareaform/areainfoform/AreaInfoForm';
import AddZoneForm from '../../components/forms/addzoneform/AddZoneForm';
import EditZoneForm from '../../components/forms/editzone/ZoneInfoForm';
import AddLocationForm from '../../components/forms/addlocationform/AddLocationForm';
import AddSelection from '../../components/common/addselection/AddSelection';
import AddSiteForm from '../../components/forms/addsiteform/AddSiteForm';
import SiteLabelsForm from '../../components/forms/sitelabelsform/SiteLabelsForm';
import AddTitle from '../../components/forms/addtitle/AddTitle';
import AdminTitleBar from '../../components/common/admintitlebar/AdminTitleBar';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';
import Modal from '../../components/common/modal/Modal';
import Confirm from '../../components/common/confirm/Confirm';

export class Admin extends Component {
  state = {
    showAddModal: false,
    showAddSiteModal: false,
    showEditSiteModal: false,
    showAddAreaModal: false,
    showAddZoneModal: false,
    showAddLocationModal: false,
    showEditLocationModal: false,
    showDeleteLocationModal: false,
    showDeleteZoneModal: false,
    showDeleteAreaModal: false,
    showDeleteSiteModal: false,
		showEditSiteLabelsModal: false,
		currentSelectedSite: ''
  };
  componentDidMount() {
    //this.props.getOrgSites(localStorage.getItem('orgId'))
  }

  componentDidUpdate(prevProps) {
    const prevSites = prevProps.sites;
    const newSites = this.props.sites;
    if (prevSites !== newSites && newSites.length && isEmpty(this.props.currentSite)) {
      const newCurrentSite = newSites[0];
      this.props.setCurrentSite(newCurrentSite, true);
      this.props.getAreas(newCurrentSite.id, true, this.props.account);
    }
  }

  handleOpenZone = zoneId => {
    this.props.getLocations(this.props.account, zoneId);
  };
  handleAdd = () => {
		this.setState({ showAddModal: true, currentSelectedSite: '' });
  };
  handleAddClose = () => {
    this.resetAllForms();
    this.setState({
      showAddModal: false,
      showAddSiteModal: false,
      showAddAreaModal: false,
      showAddZoneModal: false,
      showAddLocationModal: false
    });
    this.handleEditClose();
  };
  handleEditClose = () => {
    this.resetAllForms();
    this.setState({
      showEditLocationModal: false,
      showEditSiteModal: false,
      showEditAreaModal: false,
      showEditZoneModal: false,
      showEditSiteLabelsModal: false,
      areaToEdit: null
    });
    this.props.setCurrentLocation({});
  };
  handleDeleteClose = () => {
    this.setState({
      showDeleteLocationModal: false,
      showDeleteZoneModal: false,
      showDeleteAreaModal: false,
      showDeleteSiteModal: false
    });
  };
  resetAllForms = () => {
    this.props.resetForm('addarea');
    this.props.destroyForm('editarea');
    this.props.resetForm('addzone');
    this.props.resetForm('addlocation');
    this.props.destroyForm('sitelabels');
  };
  handleAddSelection = ({ value }) => {
    if (value === 'Site') {
			this.setState({ currentSelectedSite: '' });
    }
    this.resetAllForms();
    this.setState({ showAddModal: false, [`showAdd${value}Modal`]: true });
  };
  handleAddSiteSubmit = values => {
    let orgId = localStorage.getItem("orgId");
    let data = {...values, organizationId: orgId};
    this.props.siteAdd(data);
    this.handleAddClose();
  };
  handleAddAreaSubmit = values => {
    values.account = values.site.account;
    if (values.file && values.file.length) {
      values.file[0].account = values.site.account;
    }
    this.props.areaAdd(values);
    // This is needed to avoid memory leaks (https://react-dropzone.netlify.com/)
    if (values.file) {
      URL.revokeObjectURL(values.file.preview);
    }
    this.resetAllForms();
    this.handleAddClose();
  };
  handleEditArea = area => {
    this.setState({
      showEditAreaModal: true,
      areaToEdit: area
    });
  };
  handleEditAreaSubmit = values => {
    this.props.editArea(values);
    this.resetAllForms();
    this.handleAddClose();
  };
  handleEditZone = zone => {
    this.setState({
      showEditZoneModal: true,
      zoneToEdit: zone
    });
  };
  handleAddZoneSubmit = values => {
    values.account = values.site.account;
    this.props.zoneAdd(values);
    this.resetAllForms();
    this.handleAddClose();
  };
  handleEditZoneSubmit = values =>{
    this.props.editZone(values);
    this.resetAllForms();
    this.handleAddClose();
  };
  handleAddLocationSubmit = values => {
    values.account = values.site.account;
    this.props.locationAdd(values);
    this.props.setCurrentLocation({});
    this.resetAllForms();
    this.handleAddClose();
  };
  handleSelectAreaForLocation = area => {
    this.props.areaExpand(area);
    this.props.getZones(area.id);
  };
  handleEditLocation = location => {
    let site = this.props.sites.find(site => site.id === location.site.id);
    let area = this.props.areas[location.site.id].find(
      area => area.id === location.area.id
    );
    let zone = this.props.zones[area.id].find(
      zone => zone.id === location.zone.id
    );
    location = {
      ...location,
      site,
      area,
      zone
    };
    this.props.setCurrentLocation(location);
    this.handleSelectAreaForLocation(area);
    this.setState({ showEditLocationModal: true });
  };
  handleEditLocationSubmit = values => {
    this.props.locationEdit(values);
    this.resetAllForms();
    this.handleEditClose();
  };
  handleDeleteLocation = location => {
    let account = this.props.account && this.props.account.id;
    const locationInfo = {
      id: location.id,
      site: location.site.id,
      account: account,
      name: location.name,
      zone: location.zone
    };
    location.account = account;
    this.setState({
      showDeleteLocationModal: true,
      locationToDelete: locationInfo
    });
  };
  handleDeleteLocationConfirm = () => {
    this.props.deleteLocation(this.state.locationToDelete);
    this.handleDeleteClose();
  };
  handleDeleteZone = zone => {
    const zoneInfo = {
      zoneId: zone.id,
      areaId: zone.area.id,
      name: zone.name
    };
    this.setState({
      showDeleteZoneModal: true,
      zoneToDelete: zoneInfo
    });
  };
  handleDeleteZoneConfirm = () => {
    this.props.deleteZone(this.state.zoneToDelete);
    this.handleDeleteClose();
  };
  handleDeleteArea = area => {
    const areaInfo = {
      areaId: area.id,
      siteId: area.site.id,
      name: area.name
    };
    this.setState({
      showDeleteAreaModal: true,
      areaToDelete: areaInfo
    });
  };
  handleDeleteAreaConfirm = () => {
    this.props.deleteArea(this.state.areaToDelete);
    this.handleDeleteClose();
  };
  handleDeleteSiteConfirm = () => {
    this.props.deleteSite(this.state.siteToDelete);
    this.handleDeleteClose();
  };
  handleDeleteSite = site => {
    this.setState({
      showDeleteSiteModal: true,
      siteToDelete: site.id
    });
  };
  handleEditSite = site => {
		this.setState({ showEditSiteModal: true, currentSelectedSite: site });
  };
  handleEditSiteSubmit = values => {
    this.props.editSite(values);
    this.resetAllForms();
    this.handleEditClose();
  };
  handleEditSiteLabels = site => {
		this.setState({ showEditSiteLabelsModal: true, currentSelectedSite: site });
  };
  handleEditSiteLabelsSubmit = site => {
    const orgId = localStorage.getItem("orgId");
    this.props.editSiteLabels(site, orgId);
    this.resetAllForms();
    this.handleEditClose();
  };
  render() {
    return (
      <div className={css(styles.base)}>
        <ErrorBoundary>
          <AdminTitleBar
            title={I18n.t('admin.admin')}
            handleAdd={this.handleAdd}
          />
        </ErrorBoundary>
        <ErrorBoundary>
          <content className={css(styles.content)}>
            <Accordion
              sites={this.props.sites}
              areas={this.props.areas}
              zones={this.props.zones}
              locations={this.props.locations}
              onOpenSite={this.props.getAreas}
              onOpenArea={this.props.getZones}
              onOpenZone={this.handleOpenZone}
              onDeleteLocation={this.handleDeleteLocation}
              onDeleteZone={this.handleDeleteZone}
              onDeleteArea={this.handleDeleteArea}
              onEditArea={this.handleEditArea}
              onEditZone={this.handleEditZone}
              onDeleteSite={this.handleDeleteSite}
              onEditLocation={this.handleEditLocation}
              onEditSite={this.handleEditSite}
              onEditSiteLabels={this.handleEditSiteLabels}
            />
          </content>
        </ErrorBoundary>
        <Modal
          isOpen={this.state.showAddModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Modal"
          title={I18n.t('add.title')}
        >
          <AddSelection
            onClick={this.handleAddSelection}
            options={[
              {
                name: I18n.t('add.addSite'),
                value: 'Site',
                iconType: ICON_TYPE.SVG,
                iconValue: 'site'
              },
              {
                name: I18n.t('add.addArea'),
                value: 'Area',
                iconType: ICON_TYPE.LINEAR,
                iconValue: 'layers'
              },
              {
                name: I18n.t('add.addZone'),
                value: 'Zone',
                iconType: ICON_TYPE.LINEAR,
                iconValue: 'map'
              },
              {
                name: I18n.t('add.addLocation'),
                value: 'Location',
                iconType: ICON_TYPE.LINEAR,
                iconValue: 'flag'
              }
            ]}
          />
        </Modal>
        <Modal
          isOpen={this.state.showAddSiteModal || this.state.showEditSiteModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Site Modal"
          title={I18n.t(
            this.state.showAddSiteModal ? 'add.site.title' : 'edit.site.title'
          )}
        >
          <AddSiteForm
            onSubmit={
              this.state.showAddSiteModal
                ? this.handleAddSiteSubmit
                : this.handleEditSiteSubmit
            }
						initialValues={this.state.currentSelectedSite}
            isEditing={this.state.showEditSiteModal}
          />
        </Modal>
        <Modal
          isOpen={this.state.showAddAreaModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Area Modal"
          title={
            <AddTitle
              default={I18n.t('add.area.title')}
              showData={this.props.showAreaData}
              data={[
                {
                  name: I18n.t('models.area.name'),
                  value: this.props.areaInfo && this.props.areaInfo.name
                },
                {
                  name: I18n.t('models.area.site'),
                  value: this.props.areaInfo && this.props.areaInfo.site
                }
              ]}
            />
          }
        >
          <AddAreaForm
            onSubmit={this.handleAddAreaSubmit}
            sites={this.props.sites}
          />
        </Modal>
        <Modal
          isOpen={this.state.showEditAreaModal}
          onRequestClose={this.handleEditClose}
          contentLabel="Edit Area Modal"
          title={I18n.t('edit.area.title')}
        >
          <AreaInfoForm
            onSubmit={this.handleEditAreaSubmit}
            area={this.state.areaToEdit}
            zones={this.props.zones}
            sites={this.props.sites}
            initialValues={this.state.areaToEdit}
          />
        </Modal>

        <Modal
          isOpen={this.state.showAddZoneModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Zone Modal"
          title={
            <AddTitle
              default={I18n.t('add.zone.title')}
              showData={this.props.showZoneData}
              data={[
                {
                  name: I18n.t('add.zone.site.label'),
                  value: this.props.zoneInfo && this.props.zoneInfo.site
                },
                {
                  name: I18n.t('add.zone.area.label'),
                  value: this.props.zoneInfo && this.props.zoneInfo.area
                },
                {
                  name: I18n.t('add.zone.zone.label'),
                  value: this.props.zoneInfo && this.props.zoneInfo.name
                }
              ]}
            />
          }
        >
          <AddZoneForm
            onSubmit={this.handleAddZoneSubmit}
            sites={this.props.sites}
            areas={this.props.areas}
            onSiteSelect={this.props.getAreas}
            onAreaSelect={this.props.areaExpand}
          />
        </Modal>
        <Modal
          isOpen={this.state.showEditZoneModal}
          onRequestClose={this.handleEditClose}
          contentLabel="Edit Zone Modal"
          title={
            <AddTitle
              default={I18n.t('edit.zone.title')}
              showData={this.props.showZoneData}
            />
          }
        >
          <EditZoneForm
            onSubmit={this.handleEditZoneSubmit}
            sites={this.props.sites}
            areas={this.props.areas}
            zone={this.state.zoneToEdit}
            initialValues={this.state.zoneToEdit}
          />
        </Modal>
        <Modal
          isOpen={
            this.state.showAddLocationModal || this.state.showEditLocationModal
          }
          onRequestClose={this.handleAddClose}
          contentLabel={
            this.state.showAddLocationModal
              ? 'Add Location Modal'
              : 'Edit Location Modal'
          }
          title={
            <AddTitle
              default={I18n.t(
                this.state.showEditLocationModal
                  ? 'add.location.title'
                  : 'edit.location.title'
              )}
              showData={this.props.showLocationData}
              data={[
                {
                  name: I18n.t('add.location.site.label'),
                  value: this.props.locationInfo && this.props.locationInfo.site
                },
                {
                  name: I18n.t('add.location.area.label'),
                  value: this.props.locationInfo && this.props.locationInfo.area
                },
                {
                  name: I18n.t('add.location.zone.label'),
                  value: this.props.locationInfo && this.props.locationInfo.zone
                },
                {
                  name: I18n.t('add.location.location.label'),
                  value:
                    this.props.locationInfo && this.props.locationInfo.location
                }
              ]}
            />
          }
        >
          <AddLocationForm
            onSubmit={
              this.state.showAddLocationModal
                ? this.handleAddLocationSubmit
                : this.handleEditLocationSubmit
            }
            sites={this.props.sites}
            areas={this.props.areas}
            zones={this.props.zones}
            onSiteSelect={this.props.getAreas}
            onAreaSelect={this.handleSelectAreaForLocation}
            initialValues={this.props.currentLocation}
            isEditing={this.state.showEditLocationModal}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteLocationModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Location"
          title={I18n.t('delete.deleteLocation')}
        >
          <Confirm
            itemName={
              this.state.locationToDelete && this.state.locationToDelete.name
            }
            confirm={this.handleDeleteLocationConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteZoneModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Zone"
          title={I18n.t('delete.deleteZone')}
        >
          <Confirm
            itemName={this.state.zoneToDelete && this.state.zoneToDelete.name}
            confirm={this.handleDeleteZoneConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteAreaModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Area"
          title={I18n.t('delete.deleteArea')}
        >
          <Confirm
            itemName={this.state.areaToDelete && this.state.areaToDelete.name}
            confirm={this.handleDeleteAreaConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteSiteModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Site"
          title={I18n.t('delete.deleteSite')}
        >
          <Confirm
            itemName={this.state.siteToDelete && this.state.siteToDelete.name}
            confirm={this.handleDeleteSiteConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showEditSiteLabelsModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Site Labels"
          title={I18n.t('edit.labels.siteLabels')}
        >
          <SiteLabelsForm
            onSubmit={this.handleEditSiteLabelsSubmit}
            initialValues={this.state.currentSelectedSite}
            onCancel={this.handleAddClose}
          />
        </Modal>
      </div>
    );
  }
}

const addAreaSelector = formValueSelector('addarea');
const addZoneSelector = formValueSelector('addzone');
const addLocationSelector = formValueSelector('addlocation');

const mapStateToProps = state => {
  let areaInfo = addAreaSelector(state, 'name', 'site');
  let zoneInfo = addZoneSelector(state, 'name', 'site', 'area');
  let locationInfo = addLocationSelector(state, 'name', 'site', 'area', 'zone');
  return {
    account: state.auth.account,
    sites: state.sites.list,
    areas: state.areas.map,
    zones: state.zones.map,
    locations: state.locations.map,
    currentLocation: state.locations.currentLocation,
    currentSite: state.sites.currentSite,
    areaInfo: {
      name: areaInfo.name,
      site: areaInfo.site ? areaInfo.site.name : ''
    },
    zoneInfo: {
      name: zoneInfo.name,
      area: zoneInfo.area ? zoneInfo.area.name : '',
      site: zoneInfo.site ? zoneInfo.site.name : ''
    },
    locationInfo: {
      site: locationInfo.site ? locationInfo.site.name : '',
      area: locationInfo.area ? locationInfo.area.name : '',
      zone: locationInfo.zone ? locationInfo.zone.name : '',
      location: locationInfo.name
    },
    showAreaData: state.form.addarea && state.form.addarea.submitSucceeded,
    showZoneData: state.form.addzone && state.form.addzone.submitSucceeded,
    showLocationData:
      state.form.addlocation && state.form.addlocation.submitSucceeded
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetForm() {
      dispatch(reset(...arguments));
    },
    destroyForm() {
      dispatch(destroy(...arguments));
    },
    siteAdd() {
      dispatch(siteAddAction(...arguments));
    },
    getSites() {
      dispatch(getOrgSitesAction(...arguments));
    },
    getOrgSites(orgid){
      dispatch(getOrgSitesAction(orgid));
    },
    areaAdd() {
      dispatch(areaAddAction(...arguments));
    },
    editArea() {
      dispatch(editAreaAction(...arguments));
    },
    areaExpand() {
      dispatch(areaExpandAction(...arguments));
    },
    getAreas() {
      dispatch(getAreasAction(...arguments));
    },
    zoneAdd() {
      dispatch(zoneAddAction(...arguments));
    },
    getZones() {
      dispatch(getZonesAction(...arguments));
    },
    editZone(){
      dispatch(editZoneAction(...arguments));
    },
    locationAdd() {
      dispatch(locationAddAction(...arguments));
    },
    getLocations() {
      dispatch(getLocationsAction(...arguments));
    },
    setCurrentLocation() {
      dispatch(setCurrentLocationAction(...arguments));
    },
    locationEdit() {
      dispatch(locationEditAction(...arguments));
    },
    deleteLocation() {
      dispatch(deleteLocationAction(...arguments));
    },
    deleteZone() {
      dispatch(deleteZoneAction(...arguments));
    },
    deleteArea() {
      dispatch(deleteAreaAction(...arguments));
    },
    deleteSite() {
      dispatch(deleteSiteAction(...arguments));
    },
    setCurrentSite() {
      dispatch(setCurrentSiteAction(...arguments));
    },
    editSite() {
      dispatch(editSiteAction(...arguments));
    },
    editSiteLabels() {
      dispatch(editSiteLabelsAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/containers/admin/Admin.js